import { ArrowLeftOutlined } from '@ant-design/icons';
import { Modal, Typography, Button, Descriptions } from 'antd';

import { ReactComponent as CloseItemIcon } from '@/assets/images/close-item.svg';
import { CalendarEventType } from '@/features/calendar/entities/events';

import styles from './style.module.less';

type EventDetailsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  event?: CalendarEventType;
};

export const EventDetailsModal = ({
  isOpen,
  onClose,
  event,
}: EventDetailsModalProps) => {
  if (!event) return null;

  // Verificar se é evento "dia inteiro" para não mostrar horários
  const isAllDayEvent = 
    event.before_market === 'full_day' ||
    event.before_market === 'before_market' ||
    event.before_market === 'after_market';

  // Formato de data: com ou sem horário dependendo do tipo de evento
  const dateFormat = isAllDayEvent ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm';

  return (
    <Modal
      title="Detalhes do evento"
      open={isOpen}
      onCancel={onClose}
      closeIcon={<CloseItemIcon />}
      footer={
        <div className={styles.footer}>
          <Button icon={<ArrowLeftOutlined />} onClick={onClose} className={styles.backButton}>
            Voltar
          </Button>
        </div>
      }
      width={500}
      centered
      className="event-details-modal"
    >
      <Descriptions column={1}>
        <Descriptions.Item label="Título">
          <Typography.Text strong>{event.title}</Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item label="Data Início">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography.Text>{event.start_date.format(dateFormat)}</Typography.Text>
            </div>
          </div>
        </Descriptions.Item>

        <Descriptions.Item label="Data Fim">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {event.end_date && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Typography.Text>{event.end_date.format(dateFormat)}</Typography.Text>
              </div>
            )}
          </div>
        </Descriptions.Item>

        {event.local && (
          <Descriptions.Item label="Local">
            <Typography.Text>{event.local}</Typography.Text>
          </Descriptions.Item>
        )}

        <Descriptions.Item label="Tipo de Evento">
          <Typography.Text>{event.event_type.name}</Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item label="Descrição">
          <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>
            {event.description}
          </Typography.Paragraph>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};
